import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const fullWidth = css`
  width: 100%;
`;

export const text = css`
  text-align: center;
`;

export const title = css`
  margin-bottom: 1rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-bottom: 0.5rem;
  }
`;

export const marginLeft = css`
  margin-left: 0.5rem;
`;

export const marginTop = css`
  margin-top: 1.5rem;
`;

export const noStyleButton = css`
  color: ${colors.info};
  padding: 0;
  word-break: break-word;
  text-decoration: underline;
`;
